import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editLineType = ( {data, lineTypeId} : {data: IPostEditLineType | {}, lineTypeId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/LineTypes/UpdateLineType/${lineTypeId}`, data);
};

type QueryFnType = typeof editLineType;

type UseEditLineTypeOptions = {
  data: IPostEditLineType | {};
  lineTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditLineType = ({ config }: UseEditLineTypeOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία του Είδους Γραμμής.`, 500);
            console.error('Couldnt edit LineType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllLineTypes"])
            addNotification('Το Είδος Γραμμής Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editLineType,
    })
}